// @ts-nocheck

import { normalizeInfluencer } from './helpFunctions'

import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'

const AdvertiserRepository = RepositoryFactory.get('advertiser')

const SET_INFLUENCER = 'SET_INFLUENCER'
const SET_LOADING = 'SET_LOADING'
const SET_ONE_TIME_EARNINGS = 'SET_ONE_TIME_EARNINGS'
const SET_TRAFFIC_SOURCES = 'SET_TRAFFIC_SOURCES'
const SET_USER_TAGS = 'SET_USER_TAGS'

const emptyInfluencer = {
  userId: null,
  username: '',
  email: '',
  firstName: '',
  surname: '',
  socialMediaAccounts: [],
  myPageSlug: null,
  userTags: [],
  trafficSources: [],
  oneTimeEarnings: [],
}

export default {
  namespaced: true,
  state: {
    influencer: {
      ...emptyInfluencer,
    },
    loading: false,
  },
  getters: {
    influencer: (state) => state.influencer,
    loading: (state) => state.loading,
  },
  mutations: {
    [SET_INFLUENCER]: (state, influencer) => (state = state.influencer = influencer),
    [SET_LOADING]: (state, loading) => (state.loading = loading),
    [SET_ONE_TIME_EARNINGS]: (state, oneTimeEarnings) =>
      (state.influencer.oneTimeEarnings = oneTimeEarnings),
    [SET_TRAFFIC_SOURCES]: (state, trafficSources) =>
      (state.influencer.trafficSources = trafficSources),
    [SET_USER_TAGS]: (state, tags) => (state.influencer.userTags = tags),
  },
  actions: {
    fetchInfluencer({ rootState, commit }, { userId } = {}) {
      const numericUserId = Number(userId)
      commit(SET_INFLUENCER, { ...emptyInfluencer, userId: numericUserId })
      commit(SET_LOADING, true)
      AdvertiserRepository.getInfluencer(
        rootState.user.token,
        rootState.shop.shop.id,
        numericUserId,
      ).then(({ data }) => {
        const normalizedData = normalizeInfluencer(data)
        commit(SET_INFLUENCER, normalizedData)
        commit(SET_LOADING, false)
      })
    },
    addOneTimeEarning({ commit, state }, oneTimeEarning) {
      const updatedOneTimeEarnings = [...state.influencer.oneTimeEarnings, oneTimeEarning]
      commit(SET_ONE_TIME_EARNINGS, updatedOneTimeEarnings)
    },
    setTrafficSourcesOnInfluencer({ commit }, trafficSources) {
      commit(SET_TRAFFIC_SOURCES, trafficSources)
    },
    setTagsOnInfluencer({ commit }, tags) {
      commit(SET_USER_TAGS, tags)
    },
  },
}
